module.exports = __webpack_public_path__ + "static/media/RegisterImage.b5628b3b.png";